"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ViewportFade = /** @class */ (function () {
    function ViewportFade(selector) {
        var _this = this;
        this.selector = selector;
        // Remove the fade class if the element is visible in the viewport
        this.checkScrollPosition = function () {
            var viewPortTop = window.scrollY;
            var viewPortBottom = window.scrollY + (window.innerHeight / 15 * 14);
            _this.elements.forEach(function (element) {
                if (element.offsetTop < viewPortBottom) {
                    element.classList.remove('fade');
                }
            });
            var splideTracks = document.querySelectorAll('.splide__track');
            splideTracks.forEach(function (track) {
                if ((track.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.offsetTop + 350) < viewPortBottom) {
                    track.classList.remove('fade');
                }
            });
        };
        this.elements = document.querySelectorAll(this.selector);
        this.elements.forEach(function (element, index) {
            if (!element.classList.contains('fade')) {
                element.classList.add('fade');
            }
            if (index === 0) {
                _this.removeFromFirstSection(element);
            }
        });
        // Add fade class to slider to show introanimation
        var splideInterval = setInterval(function () {
            var splideTracks = document.querySelectorAll('.splide__track');
            if (document.readyState === 'complete') {
                clearInterval(splideInterval);
                splideTracks.forEach(function (track) {
                    track.classList.add('fade');
                });
            }
        }, 10);
        window.addEventListener('scroll', this.checkScrollPosition);
    }
    // Remove the fade class from the first element if the document is fully loaded
    ViewportFade.prototype.removeFromFirstSection = function (first) {
        var sectionInterval = setInterval(function () {
            if (document.readyState === 'complete') {
                first.classList.remove('fade');
                clearInterval(sectionInterval);
            }
        }, 10);
    };
    return ViewportFade;
}());
exports.default = ViewportFade;
